import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CarouselComponent } from '../../../../modules/carousel/carousel.component';
import { CarouselTile } from '../../../../modules/carousel/carousel.model';


@Component({
  selector: 'app-impressum-carousel',
  imports: [
    CarouselComponent
  ],
  templateUrl: './impressum-carousel.component.html',
  styleUrls: ['./impressum-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImpressumCarouselComponent {

  public tiles: CarouselTile[] = [
    {
      img: {
        src: 'assets/img/impress1.jpg',
        // width: 1120,
        // height: 742,
        alt: 'Start einer Regatta YSTM-Regatta',
        // srcset: [
        //   'assets/img/xs/impress1.webp 688w',
        //   'assets/img/sm/impress1.webp 912w',
        //   'assets/img/md/impress1.webp 1120w',
        //   'assets/img/lg/impress1.webp 1360w',
        //   'assets/img/xl/impress1.webp 2320w',
        // ],
        sizes: ['90vw'],
        priority: true,
      }
    },
    {
      img: {
        src: 'assets/img/impress2.jpg',
        // width: 1120,
        // height: 718,
        alt: 'Spinnaker-Training im YSTM',
        // style: 'width:100%;height:100%;object-fit:cover;object-position:50% 65%;',
        objectPosition: '50% 65%',
        // srcset: [
        //   'assets/img/xs/impress2.webp 688w',
        //   'assets/img/sm/impress2.webp 912w',
        //   'assets/img/md/impress2.webp 1120w',
        //   'assets/img/lg/impress2.webp 1360w',
        //   'assets/img/xl/impress2.webp 2320w',
        // ],
        sizes: ['90vw'],
        priority: true,
      }
    },
  ];
}
